module.exports = __webpack_public_path__ + "img/magento-setup-tuning@2x.eaa41fab.jpg";